import entriesJson from '@/content/glossary-entries.json';

export type GlossaryCalculatorLink = {
  name: string;
  path: string;
};

export type GlossaryEntry = {
  term: string;
  anchor: string;
  definition: string;
  example?: string;
  calculator?: GlossaryCalculatorLink;
};

export const glossaryEntries: GlossaryEntry[] = entriesJson as GlossaryEntry[];
